import React, { Component } from "react";
import {
  FaWhatsapp,
  FaWhatsappSquare,
  FaFacebookSquare,
  FaTwitter,
  FaPinterestSquare,
  FaInstagramSquare,
  FaPinterest,
  FaInstagram,
  FaFacebook,
} from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import background from "..//image/image/pameranMall.jpg";
import expoBG from "..//image/image/expo_back.png";
import history from "../component/history";

class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchData: {},
      dataExpo: {},
      // dataSponsor: [],
      finishLoad: false,
    };
  }

  async componentDidMount() {
    this.getExpo();
    // this.getSponsor();
    this.getDetailStand();
  }

  getExpo() {
    fetch("http://management.batikbordirfair.com/api/get_expo", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Authorization":
          "knWzcX6kP1qbSdIjFian5vJ8BTDk2koZ70HfS5TB13uM0znX4BitAh8tIwCkxyrN",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({ dataExpo: data.result[0] });
      })
      .catch((error) => console.log("parsing failed", error));
  }

  // getSponsor() {
  //   fetch("http://management.batikbordirfair.com/api/get_sponsor", {
  //     method: "GET",
  //     headers: new Headers({
  //       "Content-Type": "application/x-www-form-urlencoded",
  //       "X-Authorization":
  //         "knWzcX6kP1qbSdIjFian5vJ8BTDk2koZ70HfS5TB13uM0znX4BitAh8tIwCkxyrN",
  //     }),
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       this.setState({ dataSponsor: data.result });
  //     })
  //     .catch((error) => console.log("parsing failed", error));
  // }

  getDetailStand() {
    fetch("http://management.batikbordirfair.com/api/get_stand_by_id", {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Authorization":
          "knWzcX6kP1qbSdIjFian5vJ8BTDk2koZ70HfS5TB13uM0znX4BitAh8tIwCkxyrN",
      }),
      body: "&id_stand=" + +this.props.match.params.id,
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({ fetchData: data.result[0], finishLoad: true });
      })
      .catch((error) => console.log("parsing failed", error));
  }

  render() {
    if (this.state.finishLoad) {
      return (
        <div>
          <style
            id="popularfx-global-styles"
            type="text/css"
            dangerouslySetInnerHTML={{
              __html:
                "\n.site-header {background-color:#ffffff!important;}\n.site-title a {color:#171717!important;}\n.site-title a { font-size: 30 px; }\n.site-description {color:#171717 !important;}\n.site-description {font-size: 15px;}\n.site-footer {background-color:#171717! important;}\n\n",
            }}
          />
          <style
            id="pagelayer-global-styles"
            type="text/css"
            dangerouslySetInnerHTML={{
              __html:
                '\n.pagelayer-row-stretch-auto > .pagelayer-row-holder, .pagelayer-row-stretch-full > .pagelayer-row-holder.pagelayer-width-auto{ max-width: 1170px; margin-left: auto; margin-right: auto;}\n@media (min-width: 769px){\n\t\t\t.pagelayer-hide-desktop{\n\t\t\t\tdisplay:none !important;\n\t\t\t}\n\t\t}\n\n\t\t@media (max-width: 768px) and (min-width: 361px){\n\t\t\t.pagelayer-hide-tablet{\n\t\t\t\tdisplay:none !important;\n\t\t\t}\n\t\t}\n\n\t\t@media (max-width: 360px){\n\t\t\t.pagelayer-hide-mobile{\n\t\t\t\tdisplay:none !important;\n\t\t\t}\n\t\t}\n@media (max-width: 768px){\n\t[class^="pagelayer-offset-"],\n\t[class*=" pagelayer-offset-"] {\n\t\tmargin-left: 0;\n\t}\n\n\t.pagelayer-row .pagelayer-col {\n\t\tmargin-left: 0;\n\t\twidth: 100%;\n\t}\n\t.pagelayer-row.pagelayer-gutters .pagelayer-col {\n\t\tmargin-bottom: 16px;\n\t}\n\t.pagelayer-first-sm {\n\t\torder: -1;\n\t}\n\t.pagelayer-last-sm {\n\t\torder: 1;\n\t}\n}\n\n',
            }}
          />
          <style
            dangerouslySetInnerHTML={{
              __html:
                "\nimg.wp-smiley,\nimg.emoji {\n\tdisplay: inline !important;\n\tborder: none !important;\n\tbox-shadow: none !important;\n\theight: 1em !important;\n\twidth: 1em !important;\n\tmargin: 0 .07em !important;\n\tvertical-align: -0.1em !important;\n\tbackground: none !important;\n\tpadding: 0 !important;\n}\n",
            }}
          />
          <link
            rel="stylesheet"
            id="pagelayer-frontend-css"
            href="https://batikbordirfair.com/wp-content/plugins/pagelayer/css/givecss.php?give=pagelayer-frontend.css%2Cnivo-lightbox.css%2Canimate.min.css%2Cowl.carousel.min.css%2Cowl.theme.default.min.css%2Cfont-awesome5.min.css&amp;premium&amp;ver=1.3.9"
            media="all"
          />
          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
          ></link>
          <link
            rel="stylesheet"
            id="wp-block-library-css"
            href="http://batikbordirfair.com/wp-includes/css/dist/block-library/style.min.css?ver=5.6.2"
            media="all"
          />
          <link
            rel="stylesheet"
            id="contact-form-7-css"
            href="http://batikbordirfair.com/wp-content/plugins/contact-form-7/includes/css/styles.css?ver=5.4"
            media="all"
          />
          <link
            rel="stylesheet"
            id="popularfx-style-css"
            href="http://batikbordirfair.com/wp-content/uploads/popularfx-templates/eduhub/style.css?ver=1.1.8"
            media="all"
          />
          <link
            rel="stylesheet"
            id="popularfx-sidebar-css"
            href="http://batikbordirfair.com/wp-content/themes/popularfx/sidebar.css?ver=1.1.8"
            media="all"
          />
          <link
            rel="https://api.w.org/"
            href="http://batikbordirfair.com/wp-json/"
          />
          <link
            rel="alternate"
            type="application/json"
            href="http://batikbordirfair.com/wp-json/wp/v2/pages/138"
          />
          <link
            rel="EditURI"
            type="application/rsd+xml"
            title="RSD"
            href="http://batikbordirfair.com/xmlrpc.php?rsd"
          />
          <link
            rel="wlwmanifest"
            type="application/wlwmanifest+xml"
            href="http://batikbordirfair.com/wp-includes/wlwmanifest.xml"
          />
          <meta name="generator" content="WordPress 5.6.2" />
          <link
            rel="canonical"
            href="http://batikbordirfair.com/belanja-klik/"
          />
          <link rel="shortlink" href="http://batikbordirfair.com/?p=138" />
          <link
            rel="alternate"
            type="application/json+oembed"
            href="http://batikbordirfair.com/wp-json/oembed/1.0/embed?url=http%3A%2F%2Fbatikbordirfair.com%2Fbelanja-klik%2F"
          />
          <link
            rel="alternate"
            type="text/xml+oembed"
            href="http://batikbordirfair.com/wp-json/oembed/1.0/embed?url=http%3A%2F%2Fbatikbordirfair.com%2Fbelanja-klik%2F&format=xml"
          />
          <style
            dangerouslySetInnerHTML={{
              __html:
                ".recentcomments a{display:inline !important;padding:0 !important;margin:0 !important;}",
            }}
          />
          <link
            rel="icon"
            href="http://batikbordirfair.com/wp-content/uploads/2020/12/1-150x150.png"
            sizes="32x32"
          />
          <link
            rel="icon"
            href="http://batikbordirfair.com/wp-content/uploads/2020/12/1.png"
            sizes="192x192"
          />
          <link
            rel="apple-touch-icon"
            href="http://batikbordirfair.com/wp-content/uploads/2020/12/1.png"
          />
          <meta
            name="msapplication-TileImage"
            content="http://batikbordirfair.com/wp-content/uploads/2020/12/1.png"
          />
          <main id="primary" className="site-main">
            <article
              id="post-138"
              className="post-138 page type-page status-publish hentry"
            >
              <header className="entry-header"></header>
              {/* .entry-header */}
              <div className="entry-content">
                <div
                  pagelayer-id="cGwHZYN7UT8nnGAS"
                  className="pagelayer-row pagelayer-row-stretch-auto pagelayer-height-default"
                >
                  <style
                    pagelayer-style-id="cGwHZYN7UT8nnGAS"
                    dangerouslySetInnerHTML={{
                      __html:
                        '[pagelayer-id="cGwHZYN7UT8nnGAS"] .pagelayer-col-holder{padding: 10px}\n[pagelayer-id="cGwHZYN7UT8nnGAS"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n[pagelayer-id="cGwHZYN7UT8nnGAS"] .pagelayer-svg-top .pagelayer-shape-fill{fill:#227bc3}\n[pagelayer-id="cGwHZYN7UT8nnGAS"] .pagelayer-row-svg .pagelayer-svg-top{width:100%;height:100px}\n[pagelayer-id="cGwHZYN7UT8nnGAS"] .pagelayer-svg-bottom .pagelayer-shape-fill{fill:#e44993}\n[pagelayer-id="cGwHZYN7UT8nnGAS"] .pagelayer-row-svg .pagelayer-svg-bottom{width:100%;height:100px}\n',
                    }}
                  />
                  <div
                    className="pagelayer-auto pagelayer-width-auto"
                    style={{ marginLeft: window.innerWidth <= 768 ? 0 : 100 }}
                  >
                    <div
                      pagelayer-id="S8wgYphBOhvjyXEL"
                      className="pagelayer-col"
                    >
                      <style
                        pagelayer-style-id="S8wgYphBOhvjyXEL"
                        dangerouslySetInnerHTML={{
                          __html:
                            '[pagelayer-id="S8wgYphBOhvjyXEL"] .pagelayer-col-holder > div:not(:last-child){margin-bottom: 15px}\n[pagelayer-id="S8wgYphBOhvjyXEL"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n',
                        }}
                      />
                      <div className="pagelayer-col-holder">
                        <div
                          pagelayer-id="bU9ww8q2AkYTpkTA"
                          className="pagelayer-heading"
                        >
                          <style
                            pagelayer-style-id="bU9ww8q2AkYTpkTA"
                            dangerouslySetInnerHTML={{
                              __html:
                                '[pagelayer-id="bU9ww8q2AkYTpkTA"] .pagelayer-heading-holder *{color:#011216}\n[pagelayer-id="bU9ww8q2AkYTpkTA"] .pagelayer-heading-holder{color:#011216}\n',
                            }}
                          />
                          <div className="pagelayer-heading-holder">
                            <h2>Stand {this.state.fetchData.nama_stand}</h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  pagelayer-id="6l5c54fmwww4391x"
                  className="pagelayer-row pagelayer-row-stretch-full pagelayer-height-default"
                  style={{
                    backgroundImage: `url(${expoBG})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    justifyContent: "center",
                  }}
                >
                  <div
                    pagelayer-id="0kd6mrqtd3ojzwnh"
                    className="pagelayer-col fadeInRight pagelayer-wow pagelayer-anim-slow"
                  >
                    <style
                      pagelayer-style-id="0kd6mrqtd3ojzwnh"
                      dangerouslySetInnerHTML={{
                        __html:
                          '.pagelayer-row-holder [pagelayer-id="0kd6mrqtd3ojzwnh"]{width: 0.18%}\n[pagelayer-id="0kd6mrqtd3ojzwnh"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n[pagelayer-id="0kd6mrqtd3ojzwnh"]{padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;-webkit-animation-delay: 600ms; animation-delay: 600ms}\n@media (max-width: 768px) and (min-width: 361px){[pagelayer-id="0kd6mrqtd3ojzwnh"]{padding-top: 40px; padding-right: 15px; padding-bottom: 30px; padding-left: 15px}}\n@media (max-width: 360px){[pagelayer-id="0kd6mrqtd3ojzwnh"]{padding-top: 20px; padding-right: 10px; padding-bottom: 20px; padding-left: 10px}}\n',
                      }}
                    />
                    <div className="pagelayer-col-holder"></div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div
                      pagelayer-id="01snclndbsjpnxzq"
                      className="pagelayer-col fadeInLeft pagelayer-wow"
                      style={{
                        backgroundImage: `url(${background})`,
                        width: "80%",
                        height: "80%",
                        backgroundRepeat: "no-repeat",
                        backgroundSize:
                          window.MSCompatibleInfo != null ? "contain" : "cover",
                        backgroundPosition: "center",
                      }}
                    >
                      <div className="pagelayer-col-holder">
                        <div
                          pagelayer-id="i4vgsv6vp8ivyjdl"
                          className="pagelayer-inner_row pagelayer-row-stretch-auto pagelayer-height-default fadeInUp pagelayer-wow pagelayer-anim-slow"
                        >
                          <style
                            pagelayer-style-id="i4vgsv6vp8ivyjdl"
                            dangerouslySetInnerHTML={{
                              __html:
                                '[pagelayer-id="i4vgsv6vp8ivyjdl"]>.pagelayer-row-holder .pagelayer-col{align-content: default}\n[pagelayer-id="i4vgsv6vp8ivyjdl"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n[pagelayer-id="i4vgsv6vp8ivyjdl"] .pagelayer-svg-top .pagelayer-shape-fill{fill:#fff}\n[pagelayer-id="i4vgsv6vp8ivyjdl"] .pagelayer-row-svg .pagelayer-svg-top{width:100%;height:100px}\n[pagelayer-id="i4vgsv6vp8ivyjdl"] .pagelayer-svg-bottom .pagelayer-shape-fill{fill:#fff}\n[pagelayer-id="i4vgsv6vp8ivyjdl"] .pagelayer-row-svg .pagelayer-svg-bottom{width:100%;height:100px}\n[pagelayer-id="i4vgsv6vp8ivyjdl"]{padding-top: 10px; padding-right: 0px; padding-bottom: 10px; padding-left: 0px;-webkit-animation-delay: 600ms; animation-delay: 600ms}\n',
                            }}
                          />
                          <div className="pagelayer-row-holder pagelayer-row pagelayer-auto pagelayer-width-auto">
                            <div
                              pagelayer-id="ktw5xnuyk7hh6u9u"
                              className="pagelayer-col pagelayer-col-4"
                            >
                              <style
                                pagelayer-style-id="ktw5xnuyk7hh6u9u"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    '[pagelayer-id="ktw5xnuyk7hh6u9u"]{align-content: center !important;padding-top: 5px; padding-right: 5px; padding-bottom: 5px; padding-left: 5px}\n[pagelayer-id="ktw5xnuyk7hh6u9u"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n',
                                }}
                              />
                              <div className="pagelayer-col-holder">
                                <div
                                  pagelayer-id="UVrY9l4RqylSMZ9Z"
                                  className="pagelayer-heading"
                                  style={{
                                    marginTop: 110,
                                    justifyContent: "center",
                                    display: "flex",
                                  }}
                                >
                                  <div
                                    style={{
                                      textAlign: "center",
                                      color: "black",
                                      display: "inline-flex",
                                      backgroundColor: "white",
                                      marginRight: 65,
                                    }}
                                  >
                                    <h2>{this.state.fetchData.nama_stand}</h2>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          pagelayer-id="thk49428yh92mymq"
                          className="pagelayer-inner_row pagelayer-row-stretch-auto pagelayer-height-default fadeInUp pagelayer-wow"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          <style
                            pagelayer-style-id="thk49428yh92mymq"
                            dangerouslySetInnerHTML={{
                              __html:
                                '[pagelayer-id="thk49428yh92mymq"]>.pagelayer-row-holder .pagelayer-col{align-content: default}\n[pagelayer-id="thk49428yh92mymq"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n[pagelayer-id="thk49428yh92mymq"] .pagelayer-svg-top .pagelayer-shape-fill{fill:#fff}\n[pagelayer-id="thk49428yh92mymq"] .pagelayer-row-svg .pagelayer-svg-top{width:100%;height:100px}\n[pagelayer-id="thk49428yh92mymq"] .pagelayer-svg-bottom .pagelayer-shape-fill{fill:#fff}\n[pagelayer-id="thk49428yh92mymq"] .pagelayer-row-svg .pagelayer-svg-bottom{width:100%;height:100px}\n[pagelayer-id="thk49428yh92mymq"]{padding-top: 10px; padding-right: 0px; padding-bottom: 10px; padding-left: 0px;-webkit-animation-delay: 600ms; animation-delay: 600ms}\n',
                            }}
                          />
                          <div className="pagelayer-row-holder pagelayer-row pagelayer-auto pagelayer-width-auto">
                            <div
                              pagelayer-id="ic3sbz5d9rs12zfw"
                              className="pagelayer-col pagelayer-col-3"
                            >
                              <style
                                pagelayer-style-id="ic3sbz5d9rs12zfw"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    '[pagelayer-id="ic3sbz5d9rs12zfw"]{align-content: center !important}\n[pagelayer-id="ic3sbz5d9rs12zfw"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n',
                                }}
                              />
                              <div className="pagelayer-col-holder"></div>
                            </div>
                            <div
                              // pagelayer-id="sKy9RBnJ8NlbhogQ"
                              // className="pagelayer-col"
                              style={{
                                width: 300,
                              }}
                            >
                              <style
                                pagelayer-style-id="sKy9RBnJ8NlbhogQ"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    '[pagelayer-id="sKy9RBnJ8NlbhogQ"] .pagelayer-col-holder > div:not(:last-child){margin-bottom: 15px}\n.pagelayer-row-holder [pagelayer-id="sKy9RBnJ8NlbhogQ"]{width: 24.86%}\n[pagelayer-id="sKy9RBnJ8NlbhogQ"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n',
                                }}
                              />
                              <div className="pagelayer-col-holder">
                                <div
                                  pagelayer-id="757SvEoZXgBbx2rY"
                                  className="pagelayer-video"
                                >
                                  <div className="pagelayer-video-holder pagelayer-video-aspect-8-5">
                                    <iframe
                                      id="embed_video"
                                      className="pagelayer-video-iframe"
                                      width="100%"
                                      height="auto"
                                      src={this.state.dataExpo.url_yt}
                                      frameBorder={0}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              pagelayer-id="21jf488f1b79kkz2"
                              className="pagelayer-col"
                            >
                              <style
                                pagelayer-style-id="21jf488f1b79kkz2"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    '[pagelayer-id="21jf488f1b79kkz2"]{align-content: center !important;padding-top: 5px; padding-right: 5px; padding-bottom: 5px; padding-left: 5px}\n.pagelayer-row-holder [pagelayer-id="21jf488f1b79kkz2"]{width: 7.31%}\n[pagelayer-id="21jf488f1b79kkz2"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n',
                                }}
                              />
                              <div className="pagelayer-col-holder"></div>
                            </div>
                            <div
                              pagelayer-id="ijSqEKT6ir7cyDuf"
                              className="pagelayer-col pagelayer-col-3"
                            >
                              <style
                                pagelayer-style-id="ijSqEKT6ir7cyDuf"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    '[pagelayer-id="ijSqEKT6ir7cyDuf"] .pagelayer-col-holder > div:not(:last-child){margin-bottom: 15px}\n[pagelayer-id="ijSqEKT6ir7cyDuf"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n',
                                }}
                              />
                              <div className="pagelayer-col-holder"></div>
                            </div>
                          </div>
                        </div>
                        <div
                          pagelayer-id="F6lPd8RiDhFBC2y4"
                          className="pagelayer-inner_row pagelayer-row-stretch-auto pagelayer-height-default fadeInUp pagelayer-wow pagelayer-anim-slow"
                        >
                          <style
                            pagelayer-style-id="F6lPd8RiDhFBC2y4"
                            dangerouslySetInnerHTML={{
                              __html:
                                '[pagelayer-id="F6lPd8RiDhFBC2y4"]>.pagelayer-row-holder .pagelayer-col{align-content: default}\n[pagelayer-id="F6lPd8RiDhFBC2y4"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n[pagelayer-id="F6lPd8RiDhFBC2y4"] .pagelayer-svg-top .pagelayer-shape-fill{fill:#fff}\n[pagelayer-id="F6lPd8RiDhFBC2y4"] .pagelayer-row-svg .pagelayer-svg-top{width:100%;height:100px}\n[pagelayer-id="F6lPd8RiDhFBC2y4"] .pagelayer-svg-bottom .pagelayer-shape-fill{fill:#fff}\n[pagelayer-id="F6lPd8RiDhFBC2y4"] .pagelayer-row-svg .pagelayer-svg-bottom{width:100%;height:100px}\n[pagelayer-id="F6lPd8RiDhFBC2y4"]{padding-top: 10px; padding-right: 0px; padding-bottom: 10px; padding-left: 0px;-webkit-animation-delay: 600ms; animation-delay: 600ms}\n',
                            }}
                          />
                          <div className="pagelayer-row-holder pagelayer-row pagelayer-auto pagelayer-width-auto">
                            <div
                              pagelayer-id="UZHoUZW4dyTmtlNk"
                              className="pagelayer-col"
                            >
                              <style
                                pagelayer-style-id="UZHoUZW4dyTmtlNk"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    '[pagelayer-id="UZHoUZW4dyTmtlNk"]{align-content: center !important}\n.pagelayer-row-holder [pagelayer-id="UZHoUZW4dyTmtlNk"]{width: 30.64%}\n[pagelayer-id="UZHoUZW4dyTmtlNk"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n',
                                }}
                              />
                              <div className="pagelayer-col-holder">
                                <div
                                  pagelayer-id="dqiAP8tzmyUQuOCw"
                                  className="pagelayer-heading"
                                  align="left"
                                >
                                  <style
                                    pagelayer-style-id="dqiAP8tzmyUQuOCw"
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        '[pagelayer-id="dqiAP8tzmyUQuOCw"]{text-align: left;padding-top: 5px; padding-right: 5px; padding-bottom: 5px; padding-left: 5px}\n@media (max-width: 360px){[pagelayer-id="dqiAP8tzmyUQuOCw"]{text-align: center}}\n[pagelayer-id="dqiAP8tzmyUQuOCw"] .pagelayer-heading-holder *{color:#ffffff;font-family: Open Sans !important; font-size: 16px !important; font-style: Normal !important; font-weight: 600 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.35em !important; text-transform: Lowercase !important; letter-spacing: 0px !important; word-spacing: 0px !important}\n[pagelayer-id="dqiAP8tzmyUQuOCw"] .pagelayer-heading-holder{color:#ffffff;font-family: Open Sans !important; font-size: 16px !important; font-style: Normal !important; font-weight: 600 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.35em !important; text-transform: Lowercase !important; letter-spacing: 0px !important; word-spacing: 0px !important}\n',
                                    }}
                                  />
                                  <a href="#"></a>
                                </div>
                              </div>
                            </div>
                            <div
                              pagelayer-id="OHlMHHDZoids9w8A"
                              className="pagelayer-col"
                            >
                              <style
                                pagelayer-style-id="OHlMHHDZoids9w8A"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    '[pagelayer-id="OHlMHHDZoids9w8A"]{align-content: center !important;padding-top: 5px; padding-right: 5px; padding-bottom: 5px; padding-left: 5px}\n.pagelayer-row-holder [pagelayer-id="OHlMHHDZoids9w8A"]{width: 69.28%}\n[pagelayer-id="OHlMHHDZoids9w8A"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n',
                                }}
                              />
                              <div className="pagelayer-col-holder"></div>
                            </div>
                          </div>
                        </div>
                        <div
                          pagelayer-id="6cx4sphcekh1r8da"
                          className="pagelayer-inner_row pagelayer-row-stretch-auto pagelayer-height-default fadeInUp pagelayer-wow pagelayer-anim-slowest"
                        >
                          <style
                            pagelayer-style-id="6cx4sphcekh1r8da"
                            dangerouslySetInnerHTML={{
                              __html:
                                '[pagelayer-id="6cx4sphcekh1r8da"]>.pagelayer-row-holder .pagelayer-col{align-content: default}\n[pagelayer-id="6cx4sphcekh1r8da"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n[pagelayer-id="6cx4sphcekh1r8da"] .pagelayer-svg-top .pagelayer-shape-fill{fill:#fff}\n[pagelayer-id="6cx4sphcekh1r8da"] .pagelayer-row-svg .pagelayer-svg-top{width:100%;height:100px}\n[pagelayer-id="6cx4sphcekh1r8da"] .pagelayer-svg-bottom .pagelayer-shape-fill{fill:#fff}\n[pagelayer-id="6cx4sphcekh1r8da"] .pagelayer-row-svg .pagelayer-svg-bottom{width:100%;height:100px}\n[pagelayer-id="6cx4sphcekh1r8da"]{padding-top: 10px; padding-right: 0px; padding-bottom: 10px; padding-left: 0px;-webkit-animation-delay: 600ms; animation-delay: 600ms}\n',
                            }}
                          />
                          <div
                            className="pagelayer-row pagelayer-auto pagelayer-width-auto"
                            style={{ justifyContent: "center" }}
                          >
                            <div
                              pagelayer-id="2m5q109ew9oydpvf"
                              // className="pagelayer-col"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <style
                                pagelayer-style-id="2m5q109ew9oydpvf"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    '[pagelayer-id="2m5q109ew9oydpvf"]{align-content: center !important}\n.pagelayer-row-holder [pagelayer-id="2m5q109ew9oydpvf"]{width: 40.53%}\n[pagelayer-id="2m5q109ew9oydpvf"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n',
                                }}
                              />
                              <div
                                className="pagelayer-col-holder"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  pagelayer-id="biTUVVoNyXbZeS5k"
                                  className="pagelayer-social_grp pagelayer-scheme-official"
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <style
                                    pagelayer-style-id="biTUVVoNyXbZeS5k"
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        '[pagelayer-id="biTUVVoNyXbZeS5k"]{text-align: center;background: rgba(237,245,248,0.78)}\n[pagelayer-id="biTUVVoNyXbZeS5k"] > div{display: inline-block}\n[pagelayer-id="biTUVVoNyXbZeS5k"] .pagelayer-social{padding: 3px}\n[pagelayer-id="biTUVVoNyXbZeS5k"] .pagelayer-social-fa{font-size: 40px;-webkit-transition: all 400ms; transition: all 400ms}\n[pagelayer-id="biTUVVoNyXbZeS5k"] .pagelayer-icon-holder{font-size: 40px;-webkit-transition: all 400ms; transition: all 400ms}\n',
                                    }}
                                  />
                                  {this.state.fetchData.facebook !== null && (
                                    <div
                                      pagelayer-id="ROZm6BpIun7B8y7i"
                                      className="pagelayer-social"
                                    >
                                      <div
                                        className="pagelayer-icon-holder pagelayer-facebook-square"
                                        data-icon="fab fa-facebook-square"
                                      >
                                        <a
                                          className="pagelayer-ele-link"
                                          href={this.state.fetchData.facebook}
                                          target="_blank"
                                        >
                                          <FaFacebookSquare color="#345aa7" />
                                        </a>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.fetchData.instagram !== null && (
                                    <div
                                      pagelayer-id="lbiWa824W1wQUjLe"
                                      className="pagelayer-social"
                                    >
                                      <div
                                        className="pagelayer-icon-holder pagelayer-twitter"
                                        data-icon="fab fa-twitter"
                                      >
                                        <a
                                          className="pagelayer-ele-link"
                                          href={this.state.fetchData.instagram}
                                          target="_blank"
                                        >
                                          <FaInstagramSquare color="black" />
                                        </a>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.fetchData.twitter !== null && (
                                    <div
                                      pagelayer-id="lbiWa824W1wQUjLe"
                                      className="pagelayer-social"
                                    >
                                      <div
                                        className="pagelayer-icon-holder pagelayer-twitter"
                                        data-icon="fab fa-twitter"
                                      >
                                        <a
                                          className="pagelayer-ele-link"
                                          href={this.state.fetchData.twitter}
                                          target="_blank"
                                        >
                                          <FaTwitter color="#009ded" />
                                        </a>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.fetchData.no_wa !== null && (
                                    <div
                                      pagelayer-id="Vyc9zgzrGJiDymR9"
                                      className="pagelayer-social"
                                    >
                                      <div
                                        className="pagelayer-icon-holder pagelayer-whatsapp-square"
                                        data-icon="fab fa-whatsapp-square"
                                      >
                                        <a
                                          className="pagelayer-ele-link"
                                          href={`https://wa.me/${this.state.fetchData.no_wa}`}
                                          target="_blank"
                                        >
                                          <FaWhatsappSquare color="#1ad03f" />
                                        </a>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.fetchData.pinterest !== null && (
                                    <div
                                      pagelayer-id="97K4bHuuP8RSwMF5"
                                      className="pagelayer-social"
                                    >
                                      <div
                                        className="pagelayer-icon-holder pagelayer-pinterest-square"
                                        data-icon="fab fa-pinterest-square"
                                      >
                                        <a
                                          className="pagelayer-ele-link"
                                          href={this.state.fetchData.pinterest}
                                          target="_blank"
                                        >
                                          <FaPinterestSquare color="#c51f27" />
                                        </a>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.fetchData.email !== null && (
                                    <div
                                      pagelayer-id="97K4bHuuP8RSwMF5"
                                      className="pagelayer-social"
                                    >
                                      <div
                                        className="pagelayer-icon-holder pagelayer-pinterest-square"
                                        data-icon="fab fa-pinterest-square"
                                      >
                                        <a
                                          className="pagelayer-ele-link"
                                          href={`mailto:${this.state.fetchData.email}`}
                                        >
                                          <MdEmail color="grey" />
                                        </a>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div
                                  pagelayer-id="o8tfi5z24acy81c4"
                                  className="pagelayer-heading"
                                  align="left"
                                >
                                  <style
                                    pagelayer-style-id="o8tfi5z24acy81c4"
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        '[pagelayer-id="o8tfi5z24acy81c4"]{text-align: left;padding-top: 5px; padding-right: 5px; padding-bottom: 5px; padding-left: 5px}\n@media (max-width: 360px){[pagelayer-id="o8tfi5z24acy81c4"]{text-align: center}}\n[pagelayer-id="o8tfi5z24acy81c4"] .pagelayer-heading-holder *{color:#ffffff;font-family: Open Sans !important; font-size: 16px !important; font-style: Normal !important; font-weight: 600 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.35em !important; text-transform: Lowercase !important; letter-spacing: 0px !important; word-spacing: 0px !important}\n[pagelayer-id="o8tfi5z24acy81c4"] .pagelayer-heading-holder{color:#ffffff;font-family: Open Sans !important; font-size: 16px !important; font-style: Normal !important; font-weight: 600 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.35em !important; text-transform: Lowercase !important; letter-spacing: 0px !important; word-spacing: 0px !important}\n',
                                    }}
                                  />
                                  <a href="#"></a>
                                </div>
                              </div>
                            </div>
                            <div
                              pagelayer-id="07z884pc2oh196sg"
                              className="pagelayer-col"
                            >
                              <style
                                pagelayer-style-id="07z884pc2oh196sg"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    '[pagelayer-id="07z884pc2oh196sg"]{align-content: center !important;padding-top: 5px; padding-right: 5px; padding-bottom: 5px; padding-left: 5px}\n.pagelayer-row-holder [pagelayer-id="07z884pc2oh196sg"]{width: 59.47%}\n[pagelayer-id="07z884pc2oh196sg"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n',
                                }}
                              />
                              <div className="pagelayer-col-holder"></div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <style
                            pagelayer-style-id="t5o49m0n3h5j11ku"
                            dangerouslySetInnerHTML={{
                              __html:
                                '[pagelayer-id="t5o49m0n3h5j11ku"]>.pagelayer-row-holder .pagelayer-col{align-content: default}\n[pagelayer-id="t5o49m0n3h5j11ku"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n[pagelayer-id="t5o49m0n3h5j11ku"] .pagelayer-svg-top .pagelayer-shape-fill{fill:#fff}\n[pagelayer-id="t5o49m0n3h5j11ku"] .pagelayer-row-svg .pagelayer-svg-top{width:100%;height:100px}\n[pagelayer-id="t5o49m0n3h5j11ku"] .pagelayer-svg-bottom .pagelayer-shape-fill{fill:#fff}\n[pagelayer-id="t5o49m0n3h5j11ku"] .pagelayer-row-svg .pagelayer-svg-bottom{width:100%;height:100px}\n[pagelayer-id="t5o49m0n3h5j11ku"]{padding-top: 10px; padding-right: 0px; padding-bottom: 10px; padding-left: 0px;-webkit-animation-delay: 800ms; animation-delay: 800ms}\n',
                            }}
                          />
                          <div>
                            <div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                }}
                              >
                                <style
                                  pagelayer-style-id="biTUVVoNyXbZeS5k"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      '[pagelayer-id="biTUVVoNyXbZeS5k"]{text-align: center;background: rgba(237,245,248,0.78)}\n[pagelayer-id="biTUVVoNyXbZeS5k"] > div{display: inline-block}\n[pagelayer-id="biTUVVoNyXbZeS5k"] .pagelayer-social{padding: 3px}\n[pagelayer-id="biTUVVoNyXbZeS5k"] .pagelayer-social-fa{font-size: 40px;-webkit-transition: all 400ms; transition: all 400ms}\n[pagelayer-id="biTUVVoNyXbZeS5k"] .pagelayer-icon-holder{font-size: 40px;-webkit-transition: all 400ms; transition: all 400ms}\n',
                                  }}
                                />
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                  }}
                                >
                                  <div
                                    pagelayer-id="ROZm6BpIun7B8y7i"
                                    className="pagelayer-social"
                                  >
                                    <div
                                      className="pagelayer-icon-holder pagelayer-facebook-square"
                                      data-icon="fab fa-facebook-square"
                                    >
                                      <a
                                        className="pagelayer-image-holder"
                                        href={
                                          this.state.fetchData.url_tokopedia
                                        }
                                        pagelayer-image-link-type="custom_url"
                                      >
                                        <img
                                          style={{ width: 150 }}
                                          src="http://batikbordirfair.com/wp-content/uploads/2021/03/440-logo_tokopedia_unicorn_startup__tagar-800x450-1.jpg"
                                          title={`Kunjungi Tokopedia ${this.state.fetchData.nama_stand}`}
                                          alt={`Kunjungi Tokopedia ${this.state.fetchData.nama_stand}`}
                                        />
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                pagelayer-id="o8tfi5z24acy81c4"
                                className="pagelayer-heading"
                                align="left"
                              >
                                <style
                                  pagelayer-style-id="o8tfi5z24acy81c4"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      '[pagelayer-id="o8tfi5z24acy81c4"]{text-align: left;padding-top: 5px; padding-right: 5px; padding-bottom: 5px; padding-left: 5px}\n@media (max-width: 360px){[pagelayer-id="o8tfi5z24acy81c4"]{text-align: center}}\n[pagelayer-id="o8tfi5z24acy81c4"] .pagelayer-heading-holder *{color:#ffffff;font-family: Open Sans !important; font-size: 16px !important; font-style: Normal !important; font-weight: 600 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.35em !important; text-transform: Lowercase !important; letter-spacing: 0px !important; word-spacing: 0px !important}\n[pagelayer-id="o8tfi5z24acy81c4"] .pagelayer-heading-holder{color:#ffffff;font-family: Open Sans !important; font-size: 16px !important; font-style: Normal !important; font-weight: 600 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.35em !important; text-transform: Lowercase !important; letter-spacing: 0px !important; word-spacing: 0px !important}\n',
                                  }}
                                />
                                <a href="#"></a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          pagelayer-id="fk5h7nrtrzkdsx08"
                          className="pagelayer-inner_row pagelayer-row-stretch-auto pagelayer-height-default fadeInUp pagelayer-wow pagelayer-anim-slowest"
                        >
                          <style
                            pagelayer-style-id="fk5h7nrtrzkdsx08"
                            dangerouslySetInnerHTML={{
                              __html:
                                '[pagelayer-id="fk5h7nrtrzkdsx08"]>.pagelayer-row-holder .pagelayer-col{align-content: default}\n[pagelayer-id="fk5h7nrtrzkdsx08"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n[pagelayer-id="fk5h7nrtrzkdsx08"] .pagelayer-svg-top .pagelayer-shape-fill{fill:#fff}\n[pagelayer-id="fk5h7nrtrzkdsx08"] .pagelayer-row-svg .pagelayer-svg-top{width:100%;height:100px}\n[pagelayer-id="fk5h7nrtrzkdsx08"] .pagelayer-svg-bottom .pagelayer-shape-fill{fill:#fff}\n[pagelayer-id="fk5h7nrtrzkdsx08"] .pagelayer-row-svg .pagelayer-svg-bottom{width:100%;height:100px}\n[pagelayer-id="fk5h7nrtrzkdsx08"]{padding-top: 10px; padding-right: 0px; padding-bottom: 10px; padding-left: 0px;-webkit-animation-delay: 900ms; animation-delay: 900ms}\n',
                            }}
                          />
                          <div className="pagelayer-row-holder pagelayer-row pagelayer-auto pagelayer-width-auto">
                            <div
                              pagelayer-id="i921ne8tf4f7lt6a"
                              className="pagelayer-col pagelayer-col-9"
                            >
                              <style
                                pagelayer-style-id="i921ne8tf4f7lt6a"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    '[pagelayer-id="i921ne8tf4f7lt6a"]{align-content: center !important}\n[pagelayer-id="i921ne8tf4f7lt6a"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n',
                                }}
                              />
                              <div className="pagelayer-col-holder"></div>
                            </div>
                            <div
                              pagelayer-id="tq9f7e1mzfm7u6h7"
                              className="pagelayer-col pagelayer-col-2"
                            >
                              <style
                                pagelayer-style-id="tq9f7e1mzfm7u6h7"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    '[pagelayer-id="tq9f7e1mzfm7u6h7"]{align-content: center !important;padding-top: 5px; padding-right: 5px; padding-bottom: 5px; padding-left: 5px}\n[pagelayer-id="tq9f7e1mzfm7u6h7"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n',
                                }}
                              />
                              <div className="pagelayer-col-holder"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      pagelayer-id="0kd6mrqtd3ojzwnh"
                      className="pagelayer-col fadeInRight pagelayer-wow pagelayer-anim-slow"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <style
                        pagelayer-style-id="0kd6mrqtd3ojzwnh"
                        dangerouslySetInnerHTML={{
                          __html:
                            '.pagelayer-row-holder [pagelayer-id="0kd6mrqtd3ojzwnh"]{width: 0.18%}\n[pagelayer-id="0kd6mrqtd3ojzwnh"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n[pagelayer-id="0kd6mrqtd3ojzwnh"]{padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;-webkit-animation-delay: 600ms; animation-delay: 600ms}\n@media (max-width: 768px) and (min-width: 361px){[pagelayer-id="0kd6mrqtd3ojzwnh"]{padding-top: 40px; padding-right: 15px; padding-bottom: 30px; padding-left: 15px}}\n@media (max-width: 360px){[pagelayer-id="0kd6mrqtd3ojzwnh"]{padding-top: 20px; padding-right: 10px; padding-bottom: 20px; padding-left: 10px}}\n',
                        }}
                      />
                      <div
                        className="pagelayer-col-holder"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <button
                          class="button button1"
                          type="button"
                          onClick={() => history.replace("/")}
                        >
                          Kembali ke Denah
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* .entry-content */}
            </article>
            {/* #post-138 */}
          </main>
          {/* #main */}
          <footer className="pagelayer-footer">
            <div
              pagelayer-id="8el37J296dBrXrYU"
              className="pagelayer-row pagelayer-row-stretch-auto pagelayer-height-default"
            >
              <style
                pagelayer-style-id="8el37J296dBrXrYU"
                dangerouslySetInnerHTML={{
                  __html:
                    '[pagelayer-id="8el37J296dBrXrYU"] .pagelayer-col-holder{padding: 10px}\n[pagelayer-id="8el37J296dBrXrYU"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n[pagelayer-id="8el37J296dBrXrYU"] .pagelayer-svg-top .pagelayer-shape-fill{fill:#fff}\n[pagelayer-id="8el37J296dBrXrYU"] .pagelayer-row-svg .pagelayer-svg-top{width:100%;height:100px}\n[pagelayer-id="8el37J296dBrXrYU"] .pagelayer-svg-bottom .pagelayer-shape-fill{fill:#fff}\n[pagelayer-id="8el37J296dBrXrYU"] .pagelayer-row-svg .pagelayer-svg-bottom{width:100%;height:100px}\n[pagelayer-id="8el37J296dBrXrYU"]{padding-top: 60px; padding-right: 0px; padding-bottom: 60px; padding-left: 0px;border-style: solid;border-top-width: 2px; border-right-width: 0px; border-bottom-width: 0px; border-left-width: 0px;border-color: #f26520}\n@media (max-width: 768px) and (min-width: 361px){[pagelayer-id="8el37J296dBrXrYU"]{padding-top: 40px; padding-right: 0px; padding-bottom: 40px; padding-left: 0px}}\n@media (max-width: 360px){[pagelayer-id="8el37J296dBrXrYU"]{padding-top: 30px; padding-right: 0px; padding-bottom: 29px; padding-left: 0px}}\n',
                }}
              />
              <div className="pagelayer-row-holder pagelayer-row pagelayer-auto pagelayer-width-auto">
                <div
                  style={{
                    width: "100%",
                    flexDirection: window.innerWidth <= 768 ? "column" : "row",
                    display: "flex",
                    justifyContent: "space-around",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div
                      pagelayer-id="a4pwNhK3hNZTAcXl"
                      className="pagelayer-heading"
                      align="center"
                    >
                      <style
                        pagelayer-style-id="a4pwNhK3hNZTAcXl"
                        dangerouslySetInnerHTML={{
                          __html:
                            '[pagelayer-id="a4pwNhK3hNZTAcXl"]{text-align: left}\n[pagelayer-id="a4pwNhK3hNZTAcXl"] .pagelayer-heading-holder *{color:#343434;font-family: Source Sans Pro !important; font-size: 26px !important; font-style: Normal !important; font-weight: 400 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.5em !important; text-transform: Capitalize !important; letter-spacing: 0px !important; word-spacing: 0px !important}\n[pagelayer-id="a4pwNhK3hNZTAcXl"] .pagelayer-heading-holder{color:#343434;font-family: Source Sans Pro !important; font-size: 26px !important; font-style: Normal !important; font-weight: 400 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.5em !important; text-transform: Capitalize !important; letter-spacing: 0px !important; word-spacing: 0px !important}\n@media (max-width: 768px) and (min-width: 361px){[pagelayer-id="a4pwNhK3hNZTAcXl"] .pagelayer-heading-holder *{font-family:  !important; font-size: 22px !important; font-style:  !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}}\n@media (max-width: 768px) and (min-width: 361px){[pagelayer-id="a4pwNhK3hNZTAcXl"] .pagelayer-heading-holder{font-family:  !important; font-size: 22px !important; font-style:  !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}}\n@media (max-width: 360px){[pagelayer-id="a4pwNhK3hNZTAcXl"] .pagelayer-heading-holder *{font-family: Roboto Slab !important; font-size: 21px !important; font-style: Normal !important; font-weight: 600 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.5em !important; text-transform: Capitalize !important; letter-spacing: 0px !important; word-spacing: 0px !important}}\n@media (max-width: 360px){[pagelayer-id="a4pwNhK3hNZTAcXl"] .pagelayer-heading-holder{font-family: Roboto Slab !important; font-size: 21px !important; font-style: Normal !important; font-weight: 600 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.5em !important; text-transform: Capitalize !important; letter-spacing: 0px !important; word-spacing: 0px !important}}\n',
                        }}
                      />
                      <div className="pagelayer-heading-holder">
                        <h2>About</h2>
                      </div>
                    </div>
                    <div
                    // pagelayer-id="GDzoTg5jd4E2C48o"
                    // className="pagelayer-text"
                    >
                      <style
                        pagelayer-style-id="GDzoTg5jd4E2C48o"
                        dangerouslySetInnerHTML={{
                          __html:
                            '[pagelayer-id="GDzoTg5jd4E2C48o"]{padding-top: 0%; padding-right: 20%; padding-bottom: 0%; padding-left: 0%}\n',
                        }}
                      />
                      <div className="pagelayer-text-holder">
                        <p
                          style={{
                            fontFamily: "roboto",
                            fontSize: "15px",
                            fontWeight: 500,
                            color: "#000",
                            lineHeight: "1.5",
                          }}
                        >
                          Pameran batik Terbesar Di Indonesia Timur.
                        </p>
                      </div>
                    </div>
                    <div
                      pagelayer-id="xMdEU9fHAKU7V6mY"
                      className="pagelayer-social_grp"
                      pagelayer-animation="float"
                    >
                      <style
                        pagelayer-style-id="xMdEU9fHAKU7V6mY"
                        dangerouslySetInnerHTML={{
                          __html:
                            '[pagelayer-id="xMdEU9fHAKU7V6mY"]{text-align: left}\n[pagelayer-id="xMdEU9fHAKU7V6mY"] > div{display: inline-block}\n[pagelayer-id="xMdEU9fHAKU7V6mY"] .pagelayer-social{padding: 10px}\n[pagelayer-id="xMdEU9fHAKU7V6mY"] .pagelayer-social-fa{font-size: 22px;color: #f26520 !important;-webkit-transition: all 400ms; transition: all 400ms}\n[pagelayer-id="xMdEU9fHAKU7V6mY"] .pagelayer-icon-holder{font-size: 22px;-webkit-transition: all 400ms; transition: all 400ms}\n@media (max-width: 768px) and (min-width: 361px){[pagelayer-id="xMdEU9fHAKU7V6mY"] .pagelayer-social-fa{font-size: 20px}}\n@media (max-width: 768px) and (min-width: 361px){[pagelayer-id="xMdEU9fHAKU7V6mY"] .pagelayer-icon-holder{font-size: 20px}}\n@media (max-width: 360px){[pagelayer-id="xMdEU9fHAKU7V6mY"] .pagelayer-social-fa{font-size: 17px}}\n@media (max-width: 360px){[pagelayer-id="xMdEU9fHAKU7V6mY"] .pagelayer-icon-holder{font-size: 17px}}\n',
                        }}
                      />
                      <div
                        pagelayer-id="7j53YzRDH1pNwVfN"
                        className="pagelayer-social"
                      >
                        <div
                          className="pagelayer-icon-holder pagelayer-instagram"
                          data-icon="fab fa-instagram"
                        >
                          <a
                            className="pagelayer-ele-link"
                            href={this.state.dataExpo.facebook}
                          >
                            <FaFacebook color="#f26520" />
                          </a>
                        </div>
                      </div>
                      <div
                        pagelayer-id="7j53YzRDH1pNwVfN"
                        className="pagelayer-social"
                      >
                        <div
                          className="pagelayer-icon-holder pagelayer-instagram"
                          data-icon="fab fa-instagram"
                        >
                          <a
                            className="pagelayer-ele-link"
                            href={this.state.dataExpo.instagram}
                          >
                            <FaInstagram color="#f26520" />
                          </a>
                        </div>
                      </div>
                      <div
                        pagelayer-id="YuQMkSdBspbo18k7"
                        className="pagelayer-social"
                      >
                        <div
                          className="pagelayer-icon-holder pagelayer-pinterest-p"
                          data-icon="fa fa-pinterest-p"
                        >
                          <a
                            className="pagelayer-ele-link"
                            href={this.state.dataExpo.pinterest}
                          >
                            <FaPinterest color="#f26520" />
                          </a>
                        </div>
                      </div>
                      <div
                        pagelayer-id="v9XvwtzA4a0MLJ55"
                        className="pagelayer-social"
                      >
                        <div
                          className="pagelayer-icon-holder pagelayer-twitter"
                          data-icon="fab fa-twitter"
                        >
                          <a
                            className="pagelayer-ele-link"
                            href={this.state.dataExpo.twitter}
                          >
                            <FaTwitter color="#f26520" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <style
                      pagelayer-style-id="emiB0RJ7XGm18rwo"
                      dangerouslySetInnerHTML={{
                        __html:
                          '[pagelayer-id="emiB0RJ7XGm18rwo"] .pagelayer-col-holder > div:not(:last-child){margin-bottom: 15px}\n.pagelayer-row-holder [pagelayer-id="emiB0RJ7XGm18rwo"]{width: 33%}\n@media (max-width: 360px){.pagelayer-row-holder [pagelayer-id="emiB0RJ7XGm18rwo"]{width: 100%}}\n[pagelayer-id="emiB0RJ7XGm18rwo"] .pagelayer-background-overlay{-webkit-transition: all 400ms !important; transition: all 400ms !important}\n[pagelayer-id="emiB0RJ7XGm18rwo"]{padding-top: 0px; padding-right: 15px; padding-bottom: 0px; padding-left: 15px}\n',
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems:
                          window.innerWidth <= 768 ? "center" : "start",
                      }}
                    >
                      <div
                        pagelayer-id="7bo5rbj8Uy7vqRiw"
                        className="pagelayer-heading"
                        align="center"
                      >
                        <style
                          pagelayer-style-id="7bo5rbj8Uy7vqRiw"
                          dangerouslySetInnerHTML={{
                            __html:
                              '[pagelayer-id="7bo5rbj8Uy7vqRiw"]{text-align: left}\n[pagelayer-id="7bo5rbj8Uy7vqRiw"] .pagelayer-heading-holder *{color:#000000;font-family: Acme !important; font-size: 26px !important; font-style: Normal !important; font-weight: 400 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.5em !important; text-transform: Capitalize !important; letter-spacing: 0px !important; word-spacing: 0px !important}\n[pagelayer-id="7bo5rbj8Uy7vqRiw"] .pagelayer-heading-holder{color:#000000;font-family: Acme !important; font-size: 26px !important; font-style: Normal !important; font-weight: 400 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.5em !important; text-transform: Capitalize !important; letter-spacing: 0px !important; word-spacing: 0px !important}\n@media (max-width: 768px) and (min-width: 361px){[pagelayer-id="7bo5rbj8Uy7vqRiw"] .pagelayer-heading-holder *{font-family:  !important; font-size: 22px !important; font-style:  !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}}\n@media (max-width: 768px) and (min-width: 361px){[pagelayer-id="7bo5rbj8Uy7vqRiw"] .pagelayer-heading-holder{font-family:  !important; font-size: 22px !important; font-style:  !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}}\n@media (max-width: 360px){[pagelayer-id="7bo5rbj8Uy7vqRiw"] .pagelayer-heading-holder *{font-family: Roboto Slab !important; font-size: 20px !important; font-style: Normal !important; font-weight: 600 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.5em !important; text-transform: Capitalize !important; letter-spacing: 0px !important; word-spacing: 0px !important}}\n@media (max-width: 360px){[pagelayer-id="7bo5rbj8Uy7vqRiw"] .pagelayer-heading-holder{font-family: Roboto Slab !important; font-size: 20px !important; font-style: Normal !important; font-weight: 600 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.5em !important; text-transform: Capitalize !important; letter-spacing: 0px !important; word-spacing: 0px !important}}\n',
                          }}
                        />
                        <div className="pagelayer-heading-holder">
                          <h2>Kontak</h2>
                        </div>
                      </div>
                      <div
                        pagelayer-id="2Cii6Ccu165w6Lr2"
                        className="pagelayer-heading bounceInDown pagelayer-wow"
                      >
                        <style
                          pagelayer-style-id="2Cii6Ccu165w6Lr2"
                          dangerouslySetInnerHTML={{
                            __html:
                              '[pagelayer-id="2Cii6Ccu165w6Lr2"] .pagelayer-heading-holder *{color:#000000;font-family: Acme !important; font-size: 20px !important; font-style:  !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}\n[pagelayer-id="2Cii6Ccu165w6Lr2"] .pagelayer-heading-holder{color:#000000;font-family: Acme !important; font-size: 20px !important; font-style:  !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}\n[pagelayer-id="2Cii6Ccu165w6Lr2"]{-webkit-animation-delay: 600ms; animation-delay: 600ms}\n',
                          }}
                        />
                        <div className="pagelayer-heading-holder">
                          <h5>
                            Call Center Office
                            <br />
                            {this.state.dataExpo.no_wa}
                          </h5>
                        </div>
                      </div>
                      <div
                        pagelayer-id="MQG7osWiLyyxpjLV"
                        className="pagelayer-heading bounceInDown pagelayer-wow"
                      >
                        <style
                          pagelayer-style-id="MQG7osWiLyyxpjLV"
                          dangerouslySetInnerHTML={{
                            __html:
                              '[pagelayer-id="MQG7osWiLyyxpjLV"] .pagelayer-heading-holder *{color:#000000;font-family: Acme !important; font-size: 16px !important; font-style:  !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}\n[pagelayer-id="MQG7osWiLyyxpjLV"] .pagelayer-heading-holder{color:#000000;font-family: Acme !important; font-size: 16px !important; font-style:  !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}\n[pagelayer-id="MQG7osWiLyyxpjLV"]{-webkit-animation-delay: 600ms; animation-delay: 600ms}\n',
                          }}
                        />
                        <a href={`https://wa.me/${this.state.dataExpo.no_wa}`}>
                          <div className="pagelayer-heading-holder">
                            <h6>
                              Telp/WA
                              <br /> {this.state.dataExpo.no_wa}
                            </h6>
                          </div>
                        </a>
                      </div>
                      <div
                        pagelayer-id="RrBCSD5BB2lnBea5"
                        // className="pagelayer-btn"
                        style={{
                          padding: 15,
                          border: `2px solid white`,
                          borderRadius: 20,
                          background: "#28a745",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <style
                          pagelayer-style-id="RrBCSD5BB2lnBea5"
                          dangerouslySetInnerHTML={{
                            __html:
                              '[pagelayer-id="RrBCSD5BB2lnBea5"] a{width: 100%; text-align: center}\n[pagelayer-id="RrBCSD5BB2lnBea5"] .pagelayer-btn-text{font-family: La Belle Aurore; font-size: 16px !important; font-style: Normal !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}\n[pagelayer-id="RrBCSD5BB2lnBea5"] .pagelayer-btn-holder{font-family: La Belle Aurore; font-size: 16px !important; font-style: Normal !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important;-webkit-transition: all 400ms !important; transition: all 400ms !important;box-shadow: px px px 0px #8cea6a  !important}\n[pagelayer-id="RrBCSD5BB2lnBea5"] .pagelayer-btn-icon{padding: 0 5px}\n',
                          }}
                        />
                        <a
                          style={{ color: "white", width: 200 }}
                          href={`https://wa.me/${this.state.dataExpo.no_wa}`}
                          target="_blank"
                        >
                          <FaWhatsapp />
                          <span>
                            <h6>Hubungi Call Center Via Whatsapp</h6>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div
                      pagelayer-id="a4pwNhK3hNZTAcXl"
                      className="pagelayer-heading"
                      align="center"
                    >
                      <style
                        pagelayer-style-id="a4pwNhK3hNZTAcXl"
                        dangerouslySetInnerHTML={{
                          __html:
                            '[pagelayer-id="a4pwNhK3hNZTAcXl"]{text-align: left}\n[pagelayer-id="a4pwNhK3hNZTAcXl"] .pagelayer-heading-holder *{color:#343434;font-family: Source Sans Pro !important; font-size: 26px !important; font-style: Normal !important; font-weight: 400 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.5em !important; text-transform: Capitalize !important; letter-spacing: 0px !important; word-spacing: 0px !important}\n[pagelayer-id="a4pwNhK3hNZTAcXl"] .pagelayer-heading-holder{color:#343434;font-family: Source Sans Pro !important; font-size: 26px !important; font-style: Normal !important; font-weight: 400 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.5em !important; text-transform: Capitalize !important; letter-spacing: 0px !important; word-spacing: 0px !important}\n@media (max-width: 768px) and (min-width: 361px){[pagelayer-id="a4pwNhK3hNZTAcXl"] .pagelayer-heading-holder *{font-family:  !important; font-size: 22px !important; font-style:  !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}}\n@media (max-width: 768px) and (min-width: 361px){[pagelayer-id="a4pwNhK3hNZTAcXl"] .pagelayer-heading-holder{font-family:  !important; font-size: 22px !important; font-style:  !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}}\n@media (max-width: 360px){[pagelayer-id="a4pwNhK3hNZTAcXl"] .pagelayer-heading-holder *{font-family: Roboto Slab !important; font-size: 21px !important; font-style: Normal !important; font-weight: 600 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.5em !important; text-transform: Capitalize !important; letter-spacing: 0px !important; word-spacing: 0px !important}}\n@media (max-width: 360px){[pagelayer-id="a4pwNhK3hNZTAcXl"] .pagelayer-heading-holder{font-family: Roboto Slab !important; font-size: 21px !important; font-style: Normal !important; font-weight: 600 !important; font-variant: Normal !important; text-decoration-line: None !important; text-decoration-style: Solid !important; line-height: 1.5em !important; text-transform: Capitalize !important; letter-spacing: 0px !important; word-spacing: 0px !important}}\n',
                        }}
                      />
                      <div className="pagelayer-heading-holder">
                        <h2>Quick Links</h2>
                      </div>
                    </div>
                    <div
                      pagelayer-id="ZEKEA6cHXfNBTGgO"
                      className="pagelayer-list"
                    >
                      <style
                        pagelayer-style-id="ZEKEA6cHXfNBTGgO"
                        dangerouslySetInnerHTML={{
                          __html:
                            '[pagelayer-id="ZEKEA6cHXfNBTGgO"] li{list-style-type: none;font-family: Roboto; font-size: 15px !important; font-style:  !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}\n[pagelayer-id="ZEKEA6cHXfNBTGgO"] .pagelayer-list-icon-holder{padding-bottom: calc(15px/2); padding-top: calc(15px/2)}\n[pagelayer-id="ZEKEA6cHXfNBTGgO"] .pagelayer-list-item{color:#000000;margin-left: 10px}\n[pagelayer-id="ZEKEA6cHXfNBTGgO"] li > a{font-family: Roboto; font-size: 15px !important; font-style:  !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}\n@media (max-width: 768px) and (min-width: 361px){[pagelayer-id="ZEKEA6cHXfNBTGgO"] li{font-family: ; font-size: 14px !important; font-style:  !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}}\n@media (max-width: 768px) and (min-width: 361px){[pagelayer-id="ZEKEA6cHXfNBTGgO"] li > a{font-family: ; font-size: 14px !important; font-style:  !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}}\n@media (max-width: 360px){[pagelayer-id="ZEKEA6cHXfNBTGgO"] li{font-family: ; font-size: 13px !important; font-style:  !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}}\n@media (max-width: 360px){[pagelayer-id="ZEKEA6cHXfNBTGgO"] li > a{font-family: ; font-size: 13px !important; font-style:  !important; font-weight:  !important; font-variant:  !important; text-decoration-line:  !important; text-decoration-style: Solid !important; line-height: em !important; text-transform:  !important; letter-spacing: px !important; word-spacing: px !important}}\n[pagelayer-id="ZEKEA6cHXfNBTGgO"] i{color:#0986c0}\n',
                        }}
                      />
                      <ul className="pagelayer-list-ul pagelayer-list-type-none">
                        <div
                          pagelayer-id="0qlL3IiXnSICN3bG"
                          className="pagelayer-list_item"
                          style={{ marginBottom: 3 }}
                        >
                          <li className="pagelayer-list-li">
                            <a
                              className="pagelayer-list-url pagelayer-ele-link"
                              href="http://batikbordirfair.com/"
                            >
                              <span className="pagelayer-list-icon-holder">
                                <span className="pagelayer-list-item">
                                  Home
                                </span>
                              </span>
                            </a>
                          </li>
                        </div>
                        <div
                          pagelayer-id="0qlL3IiXnSICN3bG"
                          className="pagelayer-list_item"
                          style={{ marginBottom: 3 }}
                        >
                          <li className="pagelayer-list-li">
                            <a
                              className="pagelayer-list-url pagelayer-ele-link"
                              href="http://batikbordirfair.com/tentang-bbaf/"
                            >
                              <span className="pagelayer-list-icon-holder">
                                <span className="pagelayer-list-item">
                                  Tentang BBA
                                </span>
                              </span>
                            </a>
                          </li>
                        </div>
                        <div
                          pagelayer-id="0qlL3IiXnSICN3bG"
                          className="pagelayer-list_item"
                          style={{ marginBottom: 3 }}
                        >
                          <li className="pagelayer-list-li">
                            <a
                              className="pagelayer-list-url pagelayer-ele-link"
                              href="http://batikbordirfair.com/"
                            >
                              <span className="pagelayer-list-icon-holder">
                                <span className="pagelayer-list-item">
                                  Batik Tulis
                                </span>
                              </span>
                            </a>
                          </li>
                        </div>
                        <div
                          pagelayer-id="0qlL3IiXnSICN3bG"
                          className="pagelayer-list_item"
                          style={{ marginBottom: 3 }}
                        >
                          <li className="pagelayer-list-li">
                            <a
                              className="pagelayer-list-url pagelayer-ele-link"
                              href="http://batikbordirfair.com/services/"
                            >
                              <span className="pagelayer-list-icon-holder">
                                <span className="pagelayer-list-item">
                                  Apply
                                </span>
                              </span>
                            </a>
                          </li>
                        </div>
                        <div
                          pagelayer-id="0qlL3IiXnSICN3bG"
                          className="pagelayer-list_item"
                          style={{ marginBottom: 3 }}
                        >
                          <li className="pagelayer-list-li">
                            <a
                              className="pagelayer-list-url pagelayer-ele-link"
                              href="http://batikbordirfair.com/services/"
                            >
                              <span className="pagelayer-list-icon-holder">
                                <span className="pagelayer-list-item">
                                  News & Events
                                </span>
                              </span>
                            </a>
                          </li>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </footer>
          <link
            rel="stylesheet"
            id="pagelayer-google-font-css"
            href="https://fonts.googleapis.com/css?family=Acme%3A400%7COpen+Sans%3A600%7CAbel%3A400%7CSource+Sans+Pro%3A400%7CRoboto+Slab%3A600%7CLa+Belle+Aurore%3A400%7CRoboto%3A400&ver=1.3.9"
            media="all"
          />
        </div>
      );
    } else {
      return (
        <div>
          <p>Loading</p>
        </div>
      );
    }
  }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/Detail/Detail.js